/* eslint react/no-multi-comp: 0, react/prop-types: 0 */ // eslint-disable-next-line
import React, { useState, useEffect } from 'react';

// eslint-disable-next-line
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'react-bootstrap'; // eslint-disable-next-line
import FormGroupInput from '../../common/FormGroupInput'; // eslint-disable-next-line
import { copiriAxiosPost, copiriAxiosGet, copiriPortalRequest, getTotalAmount } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
import CopiriLoader from '../../common/CopiriLoader';
import default_org_img from '../../../assets/img/logos/no_gl_seal_light.png'; // eslint-disable-next-line
import { genPageData } from '../../langconfig/langconfig'; // eslint-disable-next-line
import CompleteTransactionData from './CompleteTransactionData';
import './payment_transacton.css';
const TransactioDetailModal = props => {
	const { transcId, pageLanguageContent } = props; //get prop data
	const [transactionData, setTransactionData] = useState([]);
	const [showLoader, setShowLoader] = useState(false);
	useEffect(() => {
		if (props.showHideTransactionModal) {
			// call fucntion the get the transaction detail data
			getTransactionDetailData(transcId);
		}
		// eslint-disable-next-line
	}, [props]);

	/* function to call API to get transaction detail data */
	function getTransactionDetailData(transcId) {
		setShowLoader(true);
		setTransactionData([]);
		copiriPortalRequest('/payments/transactions/' + transcId, config.app_version, 'get')
			.then(response => {
				if (response.data && response.data.status) {
					setTransactionData(response.data);
				}
				setShowLoader(false);
			})
			.catch(error => {
				toast.error(error.response.data.result);
				setShowLoader(false);
				//props.hideTransactionModal();
			});
	}
	return (
		<div>
			<Modal
				show={props.showHideTransactionModal}
				onHide={props.hideTransactionModal}
				size='lg'
				id='lodge_modal'
				className='transactiondetailModal'
			>
				<ModalHeader onHide={props.hideTransactionModal} closeButton>
					<Modal.Title>
						{pageLanguageContent['PMT018'] ? pageLanguageContent['PMT018'] : ''}:{' '}
						<span>{transactionData?.public_id} </span>
					</Modal.Title>
				</ModalHeader>
				{showLoader ? (
					<CopiriLoader />
				) : (
					<>
						<ModalBody>
							{transactionData.status ? (
								<>
									{transactionData.status && transactionData.status === 'Complete' ? (
										<CompleteTransactionData
											transactionData={transactionData}
											pageLanguageContent={pageLanguageContent}
										/>
									) : (
										<Row className=''>
											<Col lg={12} md={12} sm={12}>
												<h5 className='mb-2 p-3' style={{ textAlign: 'center' }}>
													{transactionData.org_seal ? (
														<img
															className='rounded-circle avatar-xl'
															width='45'
															src={transactionData.org_seal}
															alt={genPageData['GENLDG'] ? genPageData['GENLDG'] : ''}
														/>
													) : (
														<img className='rounded-circle avatar-xl' width='45' src={default_org_img} alt={genPageData['GENLDG'] ? genPageData['GENLDG'] : ''} />
													)}
													<span style={{ marginLeft: '10px' }}>
														{transactionData.status ? transactionData.status : ''}
													</span>
												</h5>
											</Col>
										</Row>
									)}
								</>
							) : (
								<Row className=''>
									<Col lg={12} md={12} sm={12}>
										<h5 className='mb-2 p-3' style={{ textAlign: 'center' }}>
											{pageLanguageContent['PMT013'] ? pageLanguageContent['PMT013'] : ''}
										</h5>
									</Col>
								</Row>
							)}
						</ModalBody>
					</>
				)}
				<ModalFooter>
					<Button color='secondary' onClick={props.hideTransactionModal}>
						{genPageData['GENCLS'] ? genPageData['GENCLS'] : ''}
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};
export default TransactioDetailModal;
